import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhCropperComponent } from '@shared/components/ph-cropper/ph-cropper.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { HttpLoaderFactory } from 'src/app/app.functions';
import { DialogModule } from 'primeng/dialog';

@NgModule({
  declarations: [PhCropperComponent],
  exports: [PhCropperComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
    }),
    DialogModule,
  ],
})
export class PhCropperModule {}
